import { observable, runInAction } from 'mobx';
import { get } from '../utils';

class GetInfo {
    private route: string;
    @observable
    public GetInfoData: any;

    constructor(params: any) {
        this.route = params.url;
    }

    async fetch(callback?, errs?) {
        get(this.route).then((d) => {
            let data;
            if (d.data) {
                data = d.data;
                runInAction(() => {
                    this.GetInfoData = data;
                    callback && (this.GetInfoData = callback(data));
                });
            } else {
                callback && callback([]);
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }

}

export default GetInfo;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/getInfo.ts